import { render, staticRenderFns } from "./UtenteFilter.vue?vue&type=template&id=229d09fe&"
import script from "./UtenteFilter.vue?vue&type=script&lang=ts&"
export * from "./UtenteFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports